var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconPhoneWhite = function SvgIconPhoneWhite(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#fff",
    clipPath: "url(#iconPhoneWhite_svg__a)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fillOpacity: 0.12,
    rx: 4
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M9.788 4.464q-.128.047-.245.116l-.898.52-.4.226a1.26 1.26 0 0 0-.6.772c-.71 2.634-.21 5.41 1.068 7.625 1.285 2.224 3.439 4.046 6.074 4.741.322.085.658.026.948-.141l1.091-.63c.155-.096.103-.073.268-.176.736-.464.96-1.432.499-2.162l-.049-.072c-.018-.027-.034-.046-.072-.094l-1.835-2.2-.078-.089a1.89 1.89 0 0 0-2.304-.335l-.973.554-.09-.084q-.473-.45-.776-.93l-.08-.135a3.3 3.3 0 0 1-.34-.95l-.008-.048 1-.577a1.886 1.886 0 0 0 .832-2.286l-1.013-2.731a1.564 1.564 0 0 0-1.917-.949zm.397 1.194a.31.31 0 0 1 .377.132l.025.051 1.016 2.728a.625.625 0 0 1-.21.718l-.063.041-1.7.982q.068 1.464.705 2.472.575.908 1.569 1.687l.226.171 1.71-.974a.625.625 0 0 1 .738.089l.052.055 1.83 2.2a.313.313 0 0 1-.074.465l-.463.288-.433.263q-.208.124-.403.237c-2.561-.687-4.352-2.54-5.293-4.168-.934-1.619-1.643-4.096-.96-6.665l.614-.35.688-.4a.3.3 0 0 1 .049-.022",
    clipRule: "evenodd"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "iconPhoneWhite_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
};
export default SvgIconPhoneWhite;